import { ca } from '@cian/analytics';
import { IEvent, IConsumer, createConsumer, createSubscriber } from '@cian/events-log';

import { IRequestAuthenticationParameters } from './types';
import { TThunkAction } from '../../types/redux';
import { getTrackingUser } from '../../utils/analytics/getTrackingUser';
import { getUser } from '../user';

export const TOPIC_USER = 'user';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export function subscribeOnAuthentification(parameters?: IRequestAuthenticationParameters): TThunkAction {
  return (dispatch, getState) => {
    if (typeof window !== 'undefined') {
      const consumer = getUserConsumer();

      const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          if (getState().user.isAuthenticated) {
            consumer.unsubscribe(userSubscriber);

            return;
          }

          await dispatch(getUser());

          ca('user', getTrackingUser(getState()));

          if (window.__reloadHeader__) {
            window.__reloadHeader__();
          }

          if (parameters && parameters.onSuccess) {
            dispatch(parameters.onSuccess());
          }

          consumer.unsubscribe(userSubscriber);

          return;
        }

        if (event.type === 'authentication_modal_closed') {
          if (parameters && parameters.onCloseNoAuth) {
            dispatch(parameters.onCloseNoAuth());
          }

          consumer.unsubscribe(userSubscriber);
        }
      });

      consumer.subscribe(userSubscriber);
    }
  };
}
